import React from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Table,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { DownOutlined } from "@ant-design/icons";
import config from "../config";
import NewMaintenanceReportStore from "../store/NewMaintenanceReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "js-cookie";
import withRouter from "../withRouter";
import dayjs from "dayjs";

import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
const { RangePicker } = DatePicker;
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
    return val;
  });

  return arr;
};
const { Option } = Select;
class NewMaintenanceReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.newMaintenanceReportStore = new NewMaintenanceReportStore();
    this.vehicleStore = new VehicleStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectAllVehicles: false,
      selectAllServices: false,
      selectedServices: [],
      companyId: "",
      loadData: 0,
      modalVisible: false,
      column: "",
      filter: "",
      Notcompany: false,
      Notasset: false,
      expandedRowKeys: [],
      loadinnerData: {},
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
        },
        {
          title: context.translate("_BILL_NO_"),
          dataIndex: "billNo",
          key: "billNo",
        },
        {
          title: context.translate("_VEHICLE_TYPE_"),
          dataIndex: "type",
          key: "Vehicle Type",
        },

        {
          title: context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
          ),
          dataIndex: "driverName",
          key: "driverName",
        },

        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_CURRENTODOMETER_"
          ),
          dataIndex: "distance",
          key: "CurrentOdometerValue",
        },
        {
          title: context.translate("_SERVICE_TYPE_"),
          dataIndex: "serviceName",
          key: "serviceName",
        },
        {
          title: context.translate("_SERVICE_DATE_"),
          dataIndex: "serviceDate",
          key: "serviceDate",
        },
        {
          title: context.translate("_FLEET_DASHBORD_SETTING_ODOMETER_"),
          dataIndex: "currentOdometer",
          key: "currentOdometer",
        },
        {
          title: context.translate("_GARAGE_NAME_"),
          dataIndex: "garageName",
          key: "garageName",
        },

        {
          title: context.translate("_GARAGE_ADDRESS_"),
          dataIndex: "garageAddress",
          key: "garageAddress",
        },
        {
          title: context.translate("_EXTRA_WORK_DONE_"),
          dataIndex: "extraWorksDone",
          key: "extraWorksDone",
        },
        {
          title: context.translate("_AMOUNT_"),
          dataIndex: "totalAmmount",
          key: "totalAmmount",
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_LASTOILCHANGE_"
          ),
          dataIndex: "lastOilDate",
          key: "lastOilDate",
        },
        {
          title: context.translate("_LAST_TYRE_CHANGE_"),
          dataIndex: "lastTireDate",
          key: "lastTireDate",
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_LASTMAJORSERVICE_"
          ),
          dataIndex: "lastServiceDate",
          key: "lastServiceDate",
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_NEXTOILCHANGE_"
          ),
          dataIndex: "nextOil",
          key: "Next Oil Change",
        },
        {
          title: context.translate("_NEXT_TYRE_CHANGE_KM_"),
          dataIndex: "nextTire",
          key: "Next Tire Change",
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_NEXTMAJORSERVICE_"
          ),
          dataIndex: "nextService",
          key: "Next Major Service",
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          render: (_, record) => {
            const distance = record.distance || 0;

            // --- Service ---
            const serviceDiff = (record.nextService || 0) - distance;
            const serviceStatus =
              serviceDiff < 0 ? (
                <span>
                  Service -{" "}
                  <span style={{ color: "red" }}>
                    OverDue: {Math.abs(serviceDiff)} km
                  </span>
                </span>
              ) : (
                <span>
                  Service -{" "}
                  <span style={{ color: "green" }}>Due: {serviceDiff} km</span>
                </span>
              );

            // --- Oil Change ---
            const oilDiff = (record.nextOil || 0) - distance;
            const oilStatus =
              oilDiff < 0 ? (
                <span>
                  Oil Change -{" "}
                  <span style={{ color: "red" }}>
                    OverDue: {Math.abs(oilDiff)} km
                  </span>
                </span>
              ) : (
                <span>
                  Oil Change -{" "}
                  <span style={{ color: "green" }}>Due: {oilDiff} km</span>
                </span>
              );

            // --- Tire Change ---
            const tireDiff = (record.nextTire || 0) - distance;
            const tireStatus =
              tireDiff < 0 ? (
                <span>
                  Tire Change -{" "}
                  <span style={{ color: "red" }}>
                    OverDue: {Math.abs(tireDiff)} km
                  </span>
                </span>
              ) : (
                <span>
                  Tire Change -{" "}
                  <span style={{ color: "green" }}>Due: {tireDiff} km</span>
                </span>
              );

            // Combine all statuses
            return (
              <div>
                <div>{serviceStatus}</div>
                <div>{oilStatus}</div>
                <div>{tireStatus}</div>
              </div>
            );
          },
        },
      ]),
    };
    this.menuProps = {
      items: [
        {
          label: context.translate("_EXCEL_"),
          key: "excel",
        },
        {
          label: context.translate("_PDF_"),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            interval: this.state.interval,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            sid: this.state.selectedServices,
          };
          if (val.key === "excel") {
            this.newMaintenanceReportStore.exportExcel(getData);
          }
          if (val.key === "pdf") {
            this.newMaintenanceReportStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  expandedRowRender = (id) => {
    const columns = [
      {
        title: this.context.translate("_ID_"),
        dataIndex: "gId",
        key: "gId",
        width: "5%",
      },
      {
        title: this.context.translate("_ITEM_"),
        dataIndex: "item",
        key: "item",
        width: "5%",
      },
      {
        title: this.context.translate("_QUANTITY_"),
        dataIndex: "quantity",
        key: "quantity",
        width: "5%",
      },
      {
        title: this.context.translate("_PRICE_"),
        dataIndex: "price",
        key: "price",
        width: "5%",
      },
      {
        title: this.context.translate("_TOTAL_"),
        dataIndex: "grossPrice",
        key: "grossPrice",
        width: "5%",
      },
    ];

    return (
      <div className="innerGridTbl">
        <Table
          bordered
          size="small"
          style={{ padding: "20px 20px 20px 10px" }}
          columns={columns}
          // scroll={{ x: 50 }}
          dataSource={this.newMaintenanceReportStore.innerData}
          pagination={false}
        />
      </div>
    );
  };
  onExpand = async (expanded, record) => {
    const expandedRowKeys = expanded ? [record.Id] : [];
    await this.setState({ expandedRowKeys });
    console.log(record);
    if (expanded) {
      await this.handleExpandRow(record.Id);
    }
  };
  handleExpandRow = async (id) => {
    console.log(id);
    if (!this.state.loadinnerData[id]) {
      await this.newMaintenanceReportStore.loadiInnergridData(id);
      this.setState((prevState) => ({
        loadinnerData: { ...prevState.loadinnerData, [id]: true },
      }));
    }
  };

  async componentDidMount() {
    this.setState({ pageSize: 50 });
    await this.newMaintenanceReportStore.getServiceData();
    await this.setState({ column: this.state.selectedColumns });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;
      await this.newMaintenanceReportStore.loadData({ offset: 0, limit: 50 });

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({
      selectAllVehicles: false,
    });

    await this.handleAllSelectVehicles();
    await this.setState({ companyId: comp?.value });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.setState({ loadData: 1 });
  }

  async handleSearch() {
    await this.newMaintenanceReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.companyId && this.state.selectedVehicles.length > 0) {
      this.setState({ Notcompany: false, Notasset: false });
      await this.newMaintenanceReportStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        vehicleId: this.state.selectedVehicles,
        serviceId: this.state.selectedServices,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      });
      this.setState({ loadData: 1 });
    }
  };

  handleCheckboxChange = async (column) => {
    //console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleSelectAllServices = async (e) => {
    if (this.state.selectAllServices) {
      const allServices =
        this.newMaintenanceReportStore?.maintenanceService.map((val) => {
          return val.serviceId;
        });
      await this.setState({ selectedServices: allServices });
    } else {
      await this.setState({ selectedServices: [] });
    }
  };
  onDateTimeChange = (dates) => {
    console.log(dates);
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  };
  render() {
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate(
                  "_FLEET_REPORTS_NEW_MAINTENANCEREPORT_TITLE_"
                )}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction === "ltr" ? "right" : "left",
                }}
              >
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {/* Columns */}
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.newMaintenanceReportStore?.maintenanceReportStore
                      ?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button className="exportDropdown">
                    <Space>
                      {/* Export */}
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    //console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}

                <Select
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      //console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 200 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <Checkbox
                  checked={this.state.selectAllServices}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllServices: e.target.checked,
                    });
                    //console.log(e.target.checked);
                    await this.handleSelectAllServices();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}
                <Select
                  mode="multiple"
                  maxTagCount="responsive"
                  value={this.state.selectedServices}
                  onChange={(val) => {
                    this.setState({ selectedServices: val });
                    if (
                      this.newMaintenanceReportStore?.maintenanceService
                        .length > val.length
                    ) {
                      this.setState({ selectAllServices: false });
                    } else {
                      this.setState({ selectAllServices: true });
                    }
                  }}
                  onSearch={this.handleSearch}
                  fieldNames={{ label: "serviceName", value: "serviceId" }}
                  placeholder={this.context.translate("_SERVICE_TYPE_")}
                  optionFilterProp="children"
                  options={this.newMaintenanceReportStore?.maintenanceService}
                  style={{ width: 160 }}
                />
                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 380 }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />
                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction === "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={400}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            rowKey="Id"
            currentPage={this.state.currentPage}
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            pageSize={this.state.pageSize}
            total={this.newMaintenanceReportStore?.total}
            columns={this.state.column}
            dataSource={this.newMaintenanceReportStore?.maintenanceReportStore}
            loading={this.newMaintenanceReportStore?.loading}
            onChange={this.handleTableChange}
            size="middle"
            scroll={{
              x: "calc(700px + 50%)",
              y: 280,
            }}
          />
        </div>
      </>
    );
  }
}
NewMaintenanceReportList.contextType = StoreContext;
export default observer(withRouter(NewMaintenanceReportList));
